// extracted by mini-css-extract-plugin
module.exports = {"group1":"index-group1-3oMK1","layer1":"index-layer1-1ffPq","layer2":"index-layer2-1RZjY","layer3":"index-layer3-3XTQe","layer4":"index-layer4-30y0l"};